<template>
    <div class="message">
        <Collapse v-model="activeNames" accordion>
            <List v-model="listLoading" :finished="finished" finished-text="没有更多了" @load="getList">
                <CollapseItem class="messageItem" v-for="(item, index) in messageList" :name="index" :key="index">
                    <div slot="title" class="title" @click="readMessage(item.id, item.readState)">
                        <p class="titleText">{{item.title}}<em v-if="item.readState === 'UN_ACTIVATE'"></em></p>
                        <p class="time">{{item.createTime}}</p>
                    </div>
                    <div slot="right-icon" class="rightIcon">
                        {{activeNames === index ? '收起' : '展开'}}
                        <Icon :name="activeNames === index ? 'arrow-up' : 'arrow-down'" style="margin-bottom: 2vw; margin-left: 1vw;"/>
                    </div>
                    <div slot="default">
                        {{item.content}}
                    </div>
                </CollapseItem>
            </List>
        </Collapse>
    </div>
</template>

<script>
    /*
    * 我的消息
    * */
    import {Collapse, CollapseItem, Icon, List} from 'vant';
    import {getMessage, readMessageApi} from "../../../api/message";

    export default {
        name: "Message",
        components: {
            Collapse,
            CollapseItem,
            Icon,
            List
        },
        data() {
            return {
                activeNames: [],
                messageList: [],
                listLoading: false,
                finished: false,
                page: 1
            }
        },
        methods: {
            // 阅读信息
            readMessage(id, status) {
                if (status !== 'UN_ACTIVATE') return;
                readMessageApi(id).then(res => {
                    this.messageList = [];
                    this.getList();
                });
            },
            // 获取列表
            getList() {
                getMessage(this.page).then(res => {
                    this.messageList = [...this.messageList, ...res.records];
                    // 加载状态结束
                    this.listLoading = false;
                    if (res.records.length < 10) {
                        // 数据全部加载完成
                        this.finished = true;
                        return;
                    }
                    this.page++;
                });
            }
        }
    }
</script>

<style lang='less' scoped>
    .message {
        min-height: 100vh;
        background-color: #f9f9fb;

        .messageItem {
            overflow: hidden;
            width: 92vw;
            margin: 4.4vw auto 0;
            background-color: #ffffff;
            box-shadow: 0 0 2.7vw 0.5vw rgba(11, 11, 50, 0.08);
            border-radius: 1.3vw;
        }

        .title {
            display: flex;
            flex-direction: column;
            justify-content: center;
            min-height: 20vw;

            .titleText {
                margin-bottom: 2.1vw;
                font-size: 4vw;
                color: #3b3453;

                em {
                    display: inline-block;
                    width: 2vw;
                    height: 2vw;
                    margin: 0 0 0.5vw 1.5vw;
                    background-color: #ff4545;
                    border-radius: 50%;
                }
            }

            .time {
                font-size: 2.9vw;
                color: #9a98a3;
            }
        }

        .rightIcon {
            display: flex;
            align-items: flex-end;
            padding-bottom: 3vw;
            font-size: 2.9vw;
            color: #999999;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/mine/message/Message.vue